import React from "react";
import styled from "styled-components";
// import QRSample from "../../assets/images/QRSample.png";
import { default as ReactQRCode } from "react-qr-code";
import IconButton from "./Button";
import { RightNavigationIcon } from "./Icons";

// Styled component for the container
const CarePlanContainer = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 24px;
  background: #f8f8f8;
  border: 1px solid var(--Colors-Neutral-300, #e9ecef);
  border-radius: 12px;
`;

const CarePlanBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 45%;
`;

const CarePlanTitle = styled.p`
  margin-bottom: 20px;
  font-size: 20px;
  text-align: center;
  width: 250px;
  margin: 0 auto;
`;

// const QRCodeContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding: 24px;
//   background: #fff;
//   border-radius: 12px;
//   border: 1px solid var(--Colors-Neutral-300, #e9ecef);
// `;

const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--Colors-Neutral-300, #e9ecef);
  align-items: center;
`;

const ViewResourceButton = styled.div`
  display: flex;
  gap: 24px;
  max-height: 20px;
  margin-top: 100px;
`;

const QRMessage = styled.p`
  font-size: 16px;
  color: #6c757d;
  margin-top: 12px;
  text-align: center;
`;

const QRCodeDescription = styled.p`
  text-align: center;
  width: 150px;
  font-size: 20px;
  color: #104346;
`;

const QRCode = ({ resourceLink }) => {
  const handleViewResource = () => {
    if (resourceLink) {
      window.open(resourceLink, "_blank", "noopener,noreferrer");
    } else {
      // alert("No resource link provided!");
    }
  };

  return (
    <CarePlanContainer>
      {/* Digital preview side */}
      <CarePlanBox>
        <CarePlanTitle>
          This is how it’ll show on digital Care Plan
        </CarePlanTitle>
        <ViewResourceButton>
          <IconButton variant="ghost" state="idle" onClick={handleViewResource}>
            View Resources
          </IconButton>
          <RightNavigationIcon color="#004F96" />
        </ViewResourceButton>
      </CarePlanBox>
      {/* Print preview side */}
      <CarePlanBox>
        <CarePlanTitle>
          This is how it’ll show on Printed Care Plan
        </CarePlanTitle>
        <PreviewContainer>
          {resourceLink ? (
            <>
              <ReactQRCode value={resourceLink} size={150} />
              <QRCodeDescription>Scan here for resources</QRCodeDescription>
            </>
          ) : (
            <>
              <QRMessage>No resource link provided yet</QRMessage>
            </>
          )}
        </PreviewContainer>
        {/* <QRCodeContainer>
          <QRCodeImage src={QRSample} alt="QR Code" />
          <QRCodeDescription>Scan here for resources</QRCodeDescription>
        </QRCodeContainer> */}
      </CarePlanBox>
    </CarePlanContainer>
  );
};

export default QRCode;
